import React from "react";
import { IColuna } from "app/types/IColuna";

export type HeadersPesquisaPreVendasProps = {
  colunas: IColuna[];
};

// Mapa fixo — escopo de módulo, não recriado a cada chamada (item #27).
const _MAPA_COLUNAS_PRE_VENDA: Record<string, string> = {
  Id: "Nº Pré-venda",
  Descricao: "Descrição",
  DataCriacao: "Data/Hora",
  CodigoVendedor: "Vendedor",
  ItensPreVenda: "Quantidade Itens",
};

const traduzirNomeColuna = (nomeColuna: string) =>
  nomeColuna in _MAPA_COLUNAS_PRE_VENDA ? _MAPA_COLUNAS_PRE_VENDA[nomeColuna] : nomeColuna;

export const HeadersPesquisaPreVendas = React.memo((
  props: HeadersPesquisaPreVendasProps
) => {
  return (
    <tr id="PesquisaPreVendas_LinhaHeader">
      {props.colunas.map(
        (coluna) =>
          coluna.Selecionada && (
            <th
              key={coluna.Nome}
              id={`PesquisaPreVendas_HeaderColuna_${coluna.Nome}`}
            >
              {traduzirNomeColuna(coluna.Nome)}
            </th>
          )
      )}
    </tr>
  );
});
